import { Guess } from "./types";
import { HTMLAttributes } from "react";
import { useTranslation } from "react-i18next";

interface Props extends HTMLAttributes<HTMLDivElement> {
    guess: Guess;
}

const GuessCard = ({ guess, ...props }: Props) => {
    const { t } = useTranslation("member-management");

    return <div className="tw-card-flat tw-flex tw-flex-col tw-card-clickable" {...props}>
        <div className="tw-flex-1">
            <span className="tw-text-accents-7 tw-italic">{t("groups.guesser.reason", { reason: guess.reason })}</span>
        </div>
        <div className="tw-border-solid tw-border-0 tw-border-t tw-border-accents-4 tw-mt-2 tw-pt-2">
            <h5>{guess.group.title}</h5>
            <span>{guess.group.members.map(m => m.name).join(", ")}</span>
        </div>
    </div>;
};

export default GuessCard;